import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { enableES5 } from 'immer';

import React from 'react';
import ReactDOM from 'react-dom';
import '@shared/i18n';
import i18n from 'i18next';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import 'tailwindcss/tailwind.css';
import { aegisInit, aegisInitTest } from '@shared/components/aegis';
import { isIEBroswer } from '@shared/components/browserVersion';
import { config, Alert } from '@tencent/ten-design-react';
import en_US from '@tencent/ten-design-react/lib/locale/en-US';

// ie11 rematch报immer错误 fix错误
enableES5();

// ten-design国际化
i18n.language === 'en' &&
  config.set({
    locale: en_US,
  });

if (process?.env?.NODE_ENV === 'production') {
  // eslint-disable-next-line prettier/prettier
  const noop = () => { };
  console.log = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
  aegisInit();
}

if (process?.env?.NODE_ENV === 'development') {
  // 测试环境错误上报
  aegisInitTest();
}

const useIEBroswer = isIEBroswer();

ReactDOM.render(
  <React.Fragment>
    {useIEBroswer ? (
      <div className="broswer-version">
        <Alert
          type="warn"
          message="Please note that we don't support your web browser. "
          description={
            <span>
              To get the best experience, we commend upgrading to the latest{' '}
              <a href="https://www.google.com/chrome/" target="_blank" rel="noreferrer">
                Chrome
              </a>
              ,{' '}
              <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank" rel="noreferrer">
                Firefox
              </a>
              ,{' '}
              <a href="https://www.microsoft.com/en-us/edge" target="_blank" rel="noreferrer">
                Edge
              </a>
              , or{' '}
              <a href="https://support.apple.com/downloads/safari" target="_blank" rel="noreferrer">
                Safari
              </a>
              .
            </span>
          }
        />
      </div>
    ) : null}

    <App />
  </React.Fragment>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals((e) => {
//   console.log('性能数据', e)
// });
